import _         from 'lodash'
import moment    from 'moment'
import Immutable from 'immutable'

import { formatDate, dateFormat } from 'alto-utils/lib/utils'

import CanteenRepository from 'alto-react-canteen/lib/models'

import Canteen     from './canteen'
import Course      from './course'
import CourseGroup from './course_group'
import CanteenMenu from './canteen_menu'
import DailyMenu   from './daily_menu'
import GroupMenu   from './group_menu'
import CourseMenu  from './course_menu'

export default class Menu
  canteenMenuClass: CanteenMenu
  dailyMenuClass:   DailyMenu
  groupMenuClass:   GroupMenu

  constructor: (@_canteenMenus, @canteens, @dates, @courses, @groups, @settings) ->

  with: (canteenMenus) ->
    new @constructor(canteenMenus, @canteens, @dates, @courses, @groups, @settings)

  @load: (options = {}) ->
    @loadMeals(options).then (meals) => @fromMeals(meals, options)

  @loadMeals: (options = {}) ->
    @_loadMeals({ ...options, endDate: options.startDate.clone().add(options.numberOfDays - 1, 'days') })

  @fromMeals: (meals, { settings, startDate, numberOfDays }) ->
    dates    = Immutable.List(_.range(numberOfDays).map (i) -> startDate.clone().add(i, 'days'))
    canteens = meals.secondaryFor(Canteen)
    courses  = meals.secondaryFor(Course)
    groups   = meals.secondaryFor(CourseGroup)

    canteenMenus = @_canteenMenusFor(meals, canteens, courses, groups)

    new @(canteenMenus, canteens, dates, courses, groups, settings)

  @_loadMeals: ({ backend, startDate, endDate }) ->
    repository = CanteenRepository.for(backend.baseUrl)
    relation   = repository.meals.with('canteen', 'course', 'course.group')

    backend.request('GET', '/canteen/load_menu', \
                    qs: { from_date: formatDate(startDate), to_date: formatDate(endDate) })
      .then (response) -> relation.deserializeMany(response)

  @_canteenMenusFor: (meals, canteens, courses, groups) ->
    meals.groupBy('canteenID').map (forCanteen, canteenID) =>
      canteen = canteens.find(canteenID)

      dailyMenus = forCanteen
        .groupBy((meal) -> formatDate(meal.date))
        .map (forDate, formattedDate) =>
          date = moment(formattedDate, dateFormat)

          groupMenus = forDate
            .groupBy('associations.course.groupName')
            .map (forGroup, groupName) =>
              courseMenus = forGroup
                .groupBy('courseName')
                .map (forCourse, courseName) =>
                  @_courseMenuFor(canteen, date, courses.find(courseName), forCourse.entities())

              courseMenus = @_postprocessCourseMenus(courseMenus, courses)
              courseMenus.sortBy (courseMenu, courseName) -> courses.find(courseName).orderNumber

          groupMenus.sortBy (groupMenu, groupName) -> groups.find(groupName).orderNumber

      dailyMenus.sortBy (dailyMenu, date) -> date

  @_courseMenuFor: (canteen, date, course, meals) ->
    new CourseMenu(canteen, date, course, meals)

  @_postprocessCourseMenus: (courseMenus, courses) ->
    courseMenus

  forCanteen: (canteenID) ->
    canteen    = @canteens.safeFind(canteenID)
    dailyMenus = @_canteenMenus.getIn([canteenID]) or null

    new @canteenMenuClass(canteen, dailyMenus, @)

  forDate: (canteenID, date) ->
    canteen    = @canteens.safeFind(canteenID)
    groupMenus = @_canteenMenus.getIn([canteenID, formatDate(date)]) or null

    new @dailyMenuClass(canteen, date, groupMenus, @)

  forGroup: (canteenID, date, group) ->
    @safeForGroup(canteenID, date, group) or \
      throw new Error("Group menu for canteen #{canteenID}, date #{formatDate(date)} " +
                      "and group #{group.name} not found")

  safeForGroup: (canteenID, date, group) ->
    canteen     = @canteens.safeFind(canteenID)
    courseMenus = @_canteenMenus.getIn([canteenID, formatDate(date), group.name])

    canteen and courseMenus and new @groupMenuClass(canteen, date, group, courseMenus, @)

  datesWithMeals: ->
    @dates.filter (date) => @hasMealsForDate(date)

  hasMealsForDate: (date) ->
    @_canteenMenus.some (dailyMenus) -> dailyMenus.get(formatDate(date))
